/*
 * What skips the tunnel, in Access Control: for each of the admin's
 * organisations, the services and networks its laptops send straight out of
 * their own networks rather than through the tunnel (server/pkg/devicepolicy).
 * A service is named here and expanded by the server into the networks its
 * operator publishes. Everything else stays in the tunnel. Wording lives in
 * accessWords.js.
 *
 * ! file components/SkipSettings.js
 */
import React, { useState } from "react";
import { FiCornerUpRight, FiX } from "react-icons/fi";
import * as W from "./accessWords";

export default function SkipSettings({ orgs, services, send, busy, reload, toast }) {
  return (
    <div className="panel">
      <div className="panel-title">
        <FiCornerUpRight style={{ verticalAlign: "-2px", marginRight: 8 }} />
        {W.SKIP_TITLE}
      </div>
      <div className="panel-sub">{W.SKIP_LEAD}</div>
      {orgs.map((org) => (
        <OrgSkip key={org.id} org={org} many={orgs.length > 1} services={services}
          send={send} busy={busy} reload={reload} toast={toast} />
      ))}
    </div>
  );
}

function OrgSkip({ org, many, services, send, busy, reload, toast }) {
  const [skip, setSkip] = useState(() => org.policy?.skip || []);
  const [text, setText] = useState("");
  const name = org.name || org.id;
  const named = (s) => !!services[s];
  const networks = skip.filter((s) => !named(s));

  const add = () => {
    const n = text.trim();
    if (n && !skip.includes(n)) setSkip([...skip, n]);
    setText("");
  };
  const save = async () => {
    try {
      await send(`/devicepolicy/${encodeURIComponent(org.id)}`, "PUT", { skip });
      toast.success(W.skipSaved(name));
      reload();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="ac-newform" role="group" aria-label={W.skipFor(name)}>
      {many && <div className="ac-row-title">{name}</div>}
      {Object.entries(services).map(([key, svc]) => (
        <label key={key} className="ac-check">
          <input type="checkbox" checked={skip.includes(key)}
            onChange={(e) => setSkip(e.target.checked ? [...skip, key] : skip.filter((s) => s !== key))} />
          <span>{svc.name}</span>
        </label>
      ))}
      {networks.length > 0 && (
        <div className="ac-chips">
          {networks.map((n) => (
            <span key={n} className="ac-chip on ac-chip-x">
              {n}
              <button type="button" aria-label={W.removeSkip(n)} onClick={() => setSkip(skip.filter((s) => s !== n))}>
                <FiX size={11} />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="ac-form">
        <input className="ac-input narrow ac-guid" value={text} placeholder="10.20.0.0/16"
          aria-label={W.ADD_SKIP} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} />
        <button type="button" className="ac-btn" onClick={add} disabled={!text.trim()}>{W.ADD_SKIP}</button>
        <button type="button" className="ac-btn primary" onClick={save} disabled={busy}>{W.SAVE}</button>
      </div>
      <div className="ac-blurb">{W.SKIP_NOTE}</div>
    </div>
  );
}
